import { updateItems } from '@/mocks/homepage';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">更新快讯</h2>
          <p className="text-sm text-foreground-500">最新漫画章节上架记录，追更不迷路</p>
        </div>
        <div className="max-w-3xl mx-auto relative">
          {/* 时间线 */}
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>
          <div className="space-y-5">
            {updateItems.map((item) => (
              <div key={item.id} className="relative pl-10 md:pl-14">
                {/* 圆点 */}
                <span className="absolute left-[13px] md:left-[20px] top-1 w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-50"></span>
                <div className="bg-background-50 rounded-lg p-4 border border-background-200/80">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                      {item.date}
                    </span>
                    <span className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}